import React from 'react';
import styled from '../../../libs/styled.es.js';
import { getTrackingData } from '@teko/tracking';
import { Input } from '../../atoms/Input/Input.es.js';
import { Button } from '../../atoms/Button/Button.es.js';
import { useTheme } from '../../../contexts/ThemeProvider.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledSearchBar = styled.div(({ theme, tintColor, barStyle }) => {
  const bgColor = tintColor ? tintColor : theme.colors.gray100;
  const borderRadius = `var(--search-bar-border-radius ,8px)`;
  const styles = {
    display: "flex"
  };
  switch (barStyle) {
    case "nav":
      styles["backgroundColor"] = bgColor;
      styles["borderRadius"] = "8px";
      styles[".search-icon"] = {
        backgroundColor: "transparent",
        order: -1
      };
      styles[".search-input"] = {
        paddingLeft: 0
      };
      break;
    case "light": {
      styles["backgroundColor"] = "#f6f6f6";
      styles["borderRadius"] = "8px";
      styles[".search-icon"] = {
        backgroundColor: "transparent",
        order: -1
      };
      styles[".search-input"] = {
        paddingLeft: 0
      };
      break;
    }
    default:
      styles["backgroundColor"] = bgColor;
      styles.border = `1px solid ${bgColor}`;
      styles.padding = "1px";
      styles["borderRadius"] = borderRadius;
      styles["--button-icon-border-radius"] = borderRadius;
      break;
  }
  return styles;
});
const StyledInput = styled(Input)`
  border: 0;
  background-color: transparent;
  flex: 1;
  height: 100%;
`;
const SearchIcon = styled(Button)`
  height: 36px;
  width: 36px;
  border-radius: 8px;
  padding: 0;
  justify-content: center;
  border: 0;
  background-color: transparent;
`;
const SearchIconWrapper = styled.div`
  display: inline-block;
`;
const SearchBoxWrapper = styled.div`
  display: inline-block;
  width: 100%;
`;
const SearchBar = (_a) => {
  var _b = _a, {
    placeholder,
    prepend,
    searchIconProps,
    tintColor,
    barStyle,
    className,
    onClickIcon,
    onClickInput
  } = _b, inputProps = __objRest(_b, [
    "placeholder",
    "prepend",
    "searchIconProps",
    "tintColor",
    "barStyle",
    "className",
    "onClickIcon",
    "onClickInput"
  ]);
  const theme = useTheme();
  return /* @__PURE__ */ React.createElement(StyledSearchBar, {
    tintColor,
    barStyle,
    className
  }, prepend, /* @__PURE__ */ React.createElement(SearchBoxWrapper, __spreadValues({}, getTrackingData({
    isTrackContent: true,
    regionName: "headerBar",
    contentName: "searchBox"
  })), /* @__PURE__ */ React.createElement(StyledInput, __spreadValues({
    className: "search-input",
    placeholder,
    onClick: onClickInput,
    role: "searchbox",
    "aria-label": "Search"
  }, inputProps))), /* @__PURE__ */ React.createElement(SearchIconWrapper, __spreadValues({}, getTrackingData({
    isTrackContent: true,
    regionName: "headerBar",
    contentName: "searchButton"
  })), /* @__PURE__ */ React.createElement(SearchIcon, __spreadValues({
    onClick: onClickIcon,
    className: "search-icon",
    "aria-label": "Search",
    icon: { name: "search", size: 26, color: theme.colors.gray700 }
  }, searchIconProps))));
};

export { SearchBar };
